module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<div class="title">Weekly Requests</div>\n\n<div>\n    <div>\n        <table>\n\n            ';
 if (current.id > 0) {;
__p += '\n\n            <thead>\n                <tr>\n                    <th colspan="2" class="week">\n                        <div>Current Week (' +
((__t = (current.currentRange)) == null ? '' : __t) +
')</div>\n                    </th>\n                    <th colspan="3" data-animate="animated bounce infinite" class="status-' +
((__t = (current.status)) == null ? '' : __t) +
'">\n                        ';
 if (current.status === 'pending') {;
__p += '\n                        <i class="fa fa-hourglass-half"></i> Pending\n                        ';
} else if (current.status === 'not sent') {;
__p += '\n                        Rejected\n                        ';
};
__p += '\n                    </th>\n                </tr>\n                <tr>\n                    <th>Date</th>\n                    ';
 if (current.paymentMethod === 'check') {;
__p += '\n                    <th>Pay by</th>\n                    ';
};
__p += '\n                    <th>Points</th>\n                    <th data-animate="animated bounce infinite">Dollars</th>\n                    <th>Delete</th>\n                </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <td>' +
((__t = (current.currentDate)) == null ? '' : __t) +
'</td>\n                ';
 if (current.paymentMethod === 'check') {;
__p += '\n                <td>Check</td>\n                ';
};
__p += '\n                <td>' +
((__t = (current.value)) == null ? '' : __t) +
'</td>\n                <td data-animate="animated bounce infinite">$' +
((__t = (parseFloat(current.value/100).toFixed(2))) == null ? '' : __t) +
'</td>\n                <td><button class="btn-delete">delete</button></td>\n              </tr>\n              ';
 if (current.paymentMethod === 'paypal') {;
__p += '\n              <tr class="paypal">\n                <td colspan="4">To be paid to <i class="fa fa-paypal"></i> ' +
((__t = (current.paypalAccount)) == null ? '' : __t) +
'</td>\n              </tr>\n              ';
};
__p += '\n            </tbody>\n\n            ';
 } else {;
__p += '\n\n            <thead>\n            <tr>\n                <th colspan="4" class="week">\n                    <div>Current Week (' +
((__t = (current.currentRange)) == null ? '' : __t) +
')</div>\n                </th>\n            </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td colspan="4">You do not have a current request</td>\n                </tr>\n            </tbody>\n\n            ';
};
__p += '\n\n        </table>\n\n        <table>\n\n            ';
 if (prev.id > 0) {;
__p += '\n            <thead>\n                <tr>\n                    <th class="week">\n                        <div>Past Week (' +
((__t = (prev.prevRange)) == null ? '' : __t) +
')</div>\n                    </th>\n                    <th colspan="3" class="status-' +
((__t = (prev.status)) == null ? '' : __t) +
'">\n                        ';
 if (prev.status === 'sent') {;
__p += '\n                        <i class="fa fa-check-square"></i>\n                        ';
 } else if (prev.status === 'not sent') {;
__p += '\n                        <i class="fa fa-times-circle"></i>\n                        ';
};
__p += '\n                        ' +
((__t = (prev.status)) == null ? '' : __t) +
'' +
((__t = (prev.prevSentDate)) == null ? '' : __t) +
'\n                    </th>\n                </tr>\n                <tr>\n                    <th>Date</th>\n                    <th>Points</th>\n                    <th>Dollars</th>\n                    ';
 if (prev.paymentMethod === 'check') {;
__p += '\n                    <th>Paid by</th>\n                    ';
};
__p += '\n                </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <td class="process-status">\n                  Submitted on ' +
((__t = (prev.prevDate)) == null ? '' : __t) +
'<br/>\n                  ';
 if (prev.status === 'sent') {;
__p += '\n                      <span class="status-green">Accepted on Tue, 9:01 pm</span>\n                  ';
} else if (prev.status === 'not sent') {;
__p += '\n                      <span class="status-red">Rejected on Tue, 9:01 pm</span>\n                  ';
};
__p += '\n                </td>\n                <td>' +
((__t = (prev.value)) == null ? '' : __t) +
'</td>\n                <td>$' +
((__t = (parseFloat(prev.value/100).toFixed(2))) == null ? '' : __t) +
'</td>\n                ';
 if (prev.paymentMethod === 'check') {;
__p += '\n                <td>check</td>\n                ';
};
__p += '\n              </tr>\n              ';
 if (prev.paymentMethod === 'paypal') {;
__p += '\n              <tr class="paypal">\n                <td colspan="3">Paid to <i class="fa fa-paypal"></i> ' +
((__t = (prev.paypalAccount)) == null ? '' : __t) +
'</td>\n              </tr>\n              ';
};
__p += '\n            </tbody>\n\n            ';
 } else {;
__p += '\n\n            <thead>\n                <tr>\n                    <th colspan="4" class="week">\n                        <div>Past Week (' +
((__t = (prev.prevRange)) == null ? '' : __t) +
')</div>\n                    </th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td colspan="4">No request was made</td>\n                </tr>\n            </tbody>\n\n            ';
};
__p += '\n\n        </table>\n    </div>\n</div>\n\n<div class="separator"></div>';

}
return __p
}